import { appCode } from '../../config';


// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
const ComingSoon = r => require.ensure([], () => r(require('@/views/ComingSoon')), 'ComingSoon');
const Home = r => require.ensure([], () => r(require('@/views/Home')), 'Home');
const Search = r => require.ensure([], () => r(require('@/views/Search')), 'Search');
const Feature = r => require.ensure([], () => r(require('@/views/Feature')), 'Feature');


export default [
  {
    path: `/${appCode}/`,
    redirect: `/${appCode}/home`,
  },
  {
    path: `/${appCode}/home`,
    name: `${appCode}:home`,
    components: { [appCode]: Home },
  },
  {
    path: `/${appCode}/search`,
    name: `${appCode}:search`,
    components: { [appCode]: Search },
  },
  {
    path: `/${appCode}/feature/:uid`,
    name: `${appCode}:feature`,
    components: { [appCode]: Feature },
  },
  {
    path: `/${appCode}/brandprofile`,
    name: `${appCode}:brandprofile`,
    components: { [appCode]: ComingSoon },
  },
  {
    path: `/${appCode}/explore`,
    name: `${appCode}:explore`,
    components: { [appCode]: ComingSoon },
  },
  {
    path: `/${appCode}/*`,
    redirect: `/${appCode}/home`,
  },
];
